module.exports = __webpack_public_path__ + "media/images/menu/fornax-0dd58a006bbb30c80d47ab2514f359b0.jpg";